// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SYwIg,.E2mZT{color:#4a4a4a;font-size:14px;line-height:1.57;text-align:center}.SYwIg a,.E2mZT a{color:#22b6e7}.SYwIg br,.E2mZT br{display:none}@media only screen and (min-width:480px){.SYwIg br,.E2mZT br{display:block}}.yYB2o,.HAlex,.mcEXc{color:#22b6e7;text-decoration:none;-webkit-transition:.2s;transition:.2s}@media(hover:hover){.yYB2o:hover,.HAlex:hover,.mcEXc:hover{text-decoration:underline}}.yYB2o{color:inherit}.wfVCU{color:#202626;font-size:1.5rem;font-weight:400;line-height:2.25rem;margin:0;text-align:center}.ilr0_{color:#4a4a4a;font-size:12px;font-weight:400;line-height:1.83;margin:0}.SYwIg{font-weight:600;margin:0;text-align:left}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": `SYwIg`,
	"sharedMessage": `E2mZT`,
	"inheritColorLink": `yYB2o`,
	"link": `HAlex`,
	"root": `mcEXc`,
	"title": `wfVCU`,
	"subTitle": `ilr0_`
};
module.exports = ___CSS_LOADER_EXPORT___;
